/** How full a counted limit is: warning from 90 %, danger once reached. */
export type MeterState = 'ok' | 'warning' | 'danger'

/** null when the limit is 0, which means no limit. A soft limit never goes past warning. */
export function meterState(used: number, allowed: number, soft = false): MeterState | null {
  if (allowed <= 0) return null
  const share = used / allowed
  if (share >= 1) return soft ? 'warning' : 'danger'
  return share >= 0.9 ? 'warning' : 'ok'
}

export const METER_COLOR = { ok: 'default', warning: 'warning', danger: 'danger' } as const

/** The meter's fill, 0–100. */
export function meterValue(used: number, allowed: number): number {
  return allowed > 0 ? Math.min(100, Math.round((used / allowed) * 100)) : 0
}
